import React from 'react';

import styles from './Image.module.scss';


const Image = (props) => {
  const classes = [styles.Img, props.className];

  return (
    <img className={classes.join(' ')} alt='' src={props.src} onClick={props.onClick}/>
  );
};

export default Image;
